import { render, staticRenderFns } from "./PsychologistDetail.vue?vue&type=template&id=866cf868&scoped=true"
import script from "./PsychologistDetail.vue?vue&type=script&lang=js"
export * from "./PsychologistDetail.vue?vue&type=script&lang=js"
import style0 from "./PsychologistDetail.vue?vue&type=style&index=0&id=866cf868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866cf868",
  null
  
)

export default component.exports